import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const ReportProcessing = () => {

  const navigate = useNavigate();
   useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }, []);

  useEffect(() => {

    // ⏳ 5 sec கழித்து redirect
    setTimeout(() => {
      navigate("/");
    }, 3000);

  }, [navigate]);

  return (

    <div style={{
      height: "100vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "20px"
    }}>

      <div>

        <h2>✅ Your report has been sent!</h2>

          <p style={{ marginTop: "10px", color: "#555" }}>
            Your detailed reaction speed report has been successfully sent to your email.
          </p>

          <p style={{ marginTop: "10px", color: "#555" }}>
            📩 Please check your inbox (and spam folder just in case).
          </p>

        <p style={{ marginTop: "20px", fontSize: "14px" }}>
          Redirecting you to home...
        </p>

      </div>

    </div>

  );

};

export default ReportProcessing;